import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForYouSection } from './components/ForYouSection';
import { HowItWorks } from './components/HowItWorks';
import { ResultsTimeline } from './components/ResultsTimeline';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-body text-charcoal selection:bg-purple/30 selection:text-purple-dark" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <FailedSolutions data-id="element-4" />
        <Mechanism data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <ForYouSection data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <ResultsTimeline data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}